<template>
    <div class="relative">
        <div
                ref="exportSubMenu"
                :class="{ 'hidden': isExportableMenuHidden, 'opacity-100': !isExportableMenuHidden }"
                class="opacity-0 absolute right-0 z-999999 w-216px h-116px bg-white p-4 border border-black rounded-4px shadow-5-20"
        >
            <ul class="">
                <li ref="buttonExportSubMenu"
                    v-for="(option, indx) in optionsMain"
                    class="cursor-pointer h-40px hover:bg-lunar rounded-6 px-s py-11px mb-4px"
                    @click="exportableOptionClicked(option, indx)">
                    <div class="flex items-center justify-between">
                        <div class="text-14 text-onyx font-normal">{{ option.label }}</div>
                        <div><i class="feather icon-chevron-right icon"></i></div>
                    </div>
                </li>
            </ul>

        </div>

        <div :class="{ 'hidden': !isExportableSubMenuHidden, 'opacity-100': isExportableSubMenuHidden, 'top-23px': isTypeSubMenu('all'), 'top-50px': isTypeSubMenu('selected')  }"
             class="absolute opacity-0 right-217px z-999999 w-216px h-116px bg-white p-4 border border-black rounded-4px shadow-5-20"
             ref="exportableSubMenuMore">
            <ul class="">
                <li v-for="(option, indx) in options"
                    class="cursor-pointer h-40px hover:bg-lunar rounded-6 px-s py-11px mb-4px"
                    @click="exportableClicked(option, indx)">
                    <span class="text-14 text-onyx font-normal">{{ option.label }}</span>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    import HandleHideWindowsMixin from "../../mixins/HandleHideWindowMixin";

    export default {
        props: {
            hide: {
                type: Boolean,
                default: false
            },
            options: {
                type: Array,
                default: () => {
                    return [
                        {label: 'to CSV', value: 'csv', api_url: ''},
                        // {label: 'to PDF', value: 'pdf', api_url: ''}, // PDF Removed for now, see TEC-6742
                    ];
                }
            }
        },

        mixins: [HandleHideWindowsMixin],

        watch: {
            hide(val) {
                this.isExportableMenuHidden = val;
            }
        },
        data() {
            return {
                optionsMain: [
                    {label: 'Export All...', value: 'all'},
                    {label: 'Export Selected...', value: 'selected'},
                ],
                isExportableMenuHidden: this.hide,
                isExportableSubMenuHidden: false,
                exportableOption: '',
                optionSelected: ''
            }
        },
        computed: {
            isTypeSubMenu() {
                return (type) => {
                    return (this.optionSelected === type);
                };
            }
        },
        methods: {
            exportableOptionClicked(option, indx) {
                this.activateWindow(this.$refs.buttonExportSubMenu[indx], this.$refs.exportableSubMenuMore, this.closeExportableSubMenu);
                this.optionSelected = option.value;
                this.isExportableSubMenuHidden = !this.isExportableSubMenuHidden;
            },

            closeExportableSubMenu() {
                this.isExportableSubMenuHidden = false;
            },

            exportableClicked(option, indx) {
                this.export(this.optionSelected, option);
                this.isExportableSubMenuHidden = !this.isExportableSubMenuHidden;
            },
            export(optionSelected, option){
                if (option.api_url) {
                    window.open(option.api_url, "_blank");
                }else {
                    this.$emit('selected', {optionSelected, type: option.value});
                }
            }
        }
    }
</script>
